import React, { useEffect, useState } from 'react'
import { ChatApi } from '../redux/api/ChatApi'
import { ChatListItem } from './ChatListItem';
import './Chat.scss'
import { IChatProps } from '../types/IChatProps';
import { Link, useNavigate } from 'react-router-dom';
import ChatFilter, { FilterProps } from './ChatFilter';
import { useReduxDispatch, useReduxSelector } from '../redux/hooks';
import ChatCount from './ChatCount';
import { Badge, BadgeContainer } from '@progress/kendo-react-indicators';
import { Button } from '@progress/kendo-react-buttons';
import { IChat } from '../types/IChat';
import { TabStrip, TabStripContent, TabStripTab } from '@progress/kendo-react-layout';
import ChatVisibilityMenu from './ChatVisibilityMenu';
import { UserListItem } from './UserListItem';
import UserOffline from './UserOffline';
import { PartialSpinny } from './Common/Spinny';
import IChatPin from '../types/IChatPin';
import ChatMenu from './ChatMenu';
import { MarkAsRead } from '../redux/reducers/ChatSlice';
import { ChatIsUnRead } from '../util/ChatUtils';

export default function ChatList(props: IChatProps) {
    const navigate = useNavigate();
    const usersOnline = useReduxSelector(s => s.chat.usersOnline);
    //const chats = useReduxSelector(s => s.chat.chats);
    const [filter, setFilter] = useState<FilterProps>({ closed: false } as FilterProps)
    const requests = useReduxSelector(s => s.chat.requests);
    const { data: chats } = ChatApi.useGetChatsQuery(filter?.closed); //Needed to populate the ChatSlice
    const { data: pins } = ChatApi.useGetPinnedChatsQuery();
    const { data: profile } = ChatApi.useGetProfileQuery();
    const { data: visibility } = ChatApi.useGetMyVisibilityQuery();
    const [updateChat] = ChatApi.useUpdateChatMutation();
    const [pinChat] = ChatApi.usePinChatMutation();

    const [filterVisible, setFilterVisible] = useState<boolean>(!props.showHeader)
    const dispatch = useReduxDispatch();
    const [selected, setSelected] = React.useState(0);
    const handleSelect = (e) => {
        setSelected(e.selected);
    };


    var renderItems = chats?.concat(requests).filter(c => c && (!c.IsClosed || filter.closed))
        .map(c => {
            return { ...c, sortOrder: (c.StaffContact_Id ? new Date(c?.Last_Message_Date).getTime() : (new Date().getTime() + c?.Id)) }
        })
        .filter(c => c.End_User?.toLocaleLowerCase().startsWith(filter.search) || c.Staff_Name?.toLocaleLowerCase().startsWith(filter.search) || !filter.search)
        .sort((c, c2) => {
            return c2.sortOrder - c.sortOrder //(c.StaffContact_Id ? new Date().getTime() : new Date(c?.Last_Message_Date).getTime() - new Date(c2?.Last_Message_Date).getTime())
            //return new Date(c?.Last_Message_Date).getTime() - new Date(c2?.Last_Message_Date).getTime();
        })

    useEffect(() => {
        console.log('ChatList.tsx', 'chats updated', chats?.length)
    }, [chats]);


    const chatItemClicked = (e, c: IChat) => {

        if (props.chatClicked) {
            e.preventDefault();
            e.stopPropagation();

            props.chatClicked(c.ConversationId)
        }
        if (props.pinChatOnClick) {
            e.preventDefault();
            e.stopPropagation();

            console.log('chatItemClicked', c.Staff_Expanded, c.EndUser_Expanded);

            //If the chat is not expanded, expand it and pin it
            if (c.Staff_Uid === profile.Uid)
                !c.Staff_Expanded && updateChat({ ...c, Staff_Expanded: true, Staff_Pinned: true } as IChat).unwrap();
            else
                !c.EndUser_Expanded && updateChat({ ...c, EndUser_Expanded: true } as IChat).unwrap();

            if (pins.find(p => p.ConversationId === c.ConversationId && p.Pinned) == null)
                pinChat({ Chat_Id: c.Id, Contact_Id: profile.Id, Pinned: true, ConversationId: c.ConversationId } as IChatPin).unwrap();

        }

        //mark the chat as read
        if (ChatIsUnRead(profile.Uid, c))
            dispatch(MarkAsRead({ conversationId: c.ConversationId, contactId: profile.Id, unRead: false }));
    }

    function chatStarted(chat: IChat) {
        if (props.pinChatOnClick) {
            pinChat({ Chat_Id: chat.Id, Contact_Id: profile.Id, Pinned: true, ConversationId: chat.ConversationId } as IChatPin).unwrap();
        } else {
            navigate(`/chat/${chat.ConversationId}`);
        }
    }

    if (!visibility || !renderItems)
        return <PartialSpinny />

    //Only show staff that are online and not the current user
    const staff = usersOnline?.filter(u => u.Is_Staff && u.UId !== profile?.Uid);
    const userOnline = (visibility.Visibility === 1 || visibility.Visibility === 2);

    return (
        <div className='chat-list'>
            {props.showHeader &&
                <header className='header-bar'>
                    <Button icon='menu' fillMode='flat' onClick={props.toggleExpanded} ></Button>
                    <h5><BadgeContainer><Badge align={{ horizontal: 'start', vertical: 'top' }} position='outside' rounded={'full'}><ChatCount /></Badge>Active Chats</BadgeContainer></h5>
                    <Button icon='search' fillMode='flat' onClick={() => setFilterVisible((prev) => !prev)}></Button>
                    <ChatVisibilityMenu />
                </header>}
            {userOnline && filterVisible && <ChatFilter onFilterChange={(val) => setFilter(val)} />}
            {userOnline ?
                <TabStrip selected={selected} onSelect={handleSelect} className='chat-tabs'>
                    <TabStripTab title={<span>Active Chats {renderItems.length && <>(<ChatCount showZero={true} />/{renderItems.length})</>}</span>}>
                        {renderItems?.map(c =>
                            <div className='chat-item' key={c?.Id}>
                                <Link to={`./chat/${c?.ConversationId}/dialog`} onClick={(e) => chatItemClicked(e, c)}>
                                    <ChatListItem {...c} />
                                </Link>
                                <ChatMenu chat={c} profile={profile} />
                            </div>
                        )}
                        {!renderItems?.length && <div className='m-5 k-notification-info'><span className='k-icon k-i-info m-2'></span>No active chats</div>}
                    </TabStripTab>
                    <TabStripTab title={`Online Staff (${staff?.length || '0'})`}>
                        {staff.map(s => <UserListItem key={s?.UId} user={s} onChatStarted={chatStarted} />)}
                        {!staff?.length && <div className='m-5 k-notification-warning'><span className='k-icon k-i-info m-2'></span>No staff currently online</div>}
                    </TabStripTab>
                </TabStrip>
                :
                <UserOffline />}
        </div>
    )
}
